var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"management"},[_c('div',{staticClass:"picture"},[_c('a',{attrs:{"href":this.url,"target":"blank"}},[_c('img',{attrs:{"src":_vm.banner,"alt":""}})])]),_c('div',{staticClass:"main"},[_c('regulationsList'),_c('search')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }